import { Image, Nav, Navbar } from "react-bootstrap"
import logo2 from "../../assets/logo.PNG"
import { tabs } from "../../variables"
import { Link, withRouter } from "react-router-dom"
import faceIcon from "../../assets/homeImages/facebook.png"
import React from "react"

const Topbar = ({history}) => {
    return (
        <Navbar collapseOnSelect id="topBar" bg="white" variant="light" sticky='top' expand="xl"
                className="mb-5">
            <Navbar.Brand href="/">
                <Image src={logo2} className="mapHolder-logo" alt="preview"/></Navbar.Brand>
            <Navbar.Toggle aria-controls="basic-navbar-nav"/>
            <Navbar.Collapse>
                <Nav justify className="textFontTabs textBig mr-auto" variant="tabs" defaultActiveKey="/"
                     activeKey={history.location.pathname}>
                    {tabs.map(tab =>
                        (<Nav.Link as={Link} key={tab.name} to={tab.pathname}>{tab.name}</Nav.Link>))
                    }
                </Nav>
                <Image src={faceIcon} className="face-logo" alt="face-logo"
                       onClick={() => window.open("https://www.facebook.com/Custom-Map-Holder-113935510739144")}/>
            </Navbar.Collapse>
        </Navbar>
    )
}

export default withRouter(Topbar)